// extracted by mini-css-extract-plugin
export default {"needMapping":"Pari-List_needMapping__bl283","noMapping":"Pari-List_noMapping__JMPfR"};